@if (!isLoading) {
  <div class="main-container" data-cy="patient-portal-payments-main-container">
    <div class="page-header" data-cy="patient-portal-payments-header">
      Invoices
    </div>
    <mat-divider data-cy="patient-portal-payments-divider"></mat-divider>
    @if (dataPayments.length === 0) {
      <div class="no-invoices-message" data-cy="patient-portal-payments-no-invoices-message">
        You currently have no published invoices
      </div>
    }
    @if (dataPayments.length > 0) {
      <div class="payments-container" data-cy="patient-portal-payments-list-container">
        @for (paymentObj of dataPayments; track paymentObj; let i = $index) {
          <div class="payment-item" data-cy="patient-portal-payments-payment-item" [class.offset]="i % 2">
            <div class="item-detail" data-cy="patient-portal-payments-invoice-date-label">
              {{ paymentObj.DATA_INVOICE_OBJECT.invoiceDate | date }}
            </div>
            <div class="item-detail" data-cy="patient-portal-payments-payment-amount-label">
              {{ paymentObj.PaymentAmount | currency }}
            </div>
            <div class="item-detail"
              [class.paid-detail]="paymentObj.DATA_INVOICE_OBJECT.invoiceIsPaid"
              [class.unpaid-detail]="!paymentObj.DATA_INVOICE_OBJECT.invoiceIsPaid"
              data-cy="patient-portal-payments-payment-status-label">
              {{ paymentObj.DATA_INVOICE_OBJECT.invoiceIsPaid ? 'Paid' : 'Unpaid' }}
            </div>
            <div class="item-detail">
              <button mat-button color="primary" (click)="openInvoice(paymentObj)" data-cy="patient-portal-payments-open-invoice-button">Open</button>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
@if (isLoading) {
  <div class="spinner-container" data-cy="patient-portal-payments-loading-spinner-container">
    <mat-spinner data-cy="patient-portal-payments-loading-spinner"></mat-spinner>
  </div>
}
